import axios from 'axios';
import { combineReducers } from 'redux';
import { initialize as initializeForm } from 'redux-form';

import * as Urls from 'src/constants/EndpointUrls';
import { EMPLOYMENT_TYPE_FORM, EDITABLE_LIST_FIELDS_NAME } from 'src/constants/FormNames';
import createNamedWrapperReducer from 'src/reducers/createNamedWrapperReducer';
import { editableListReducer } from 'src/reducers/common';
import {
  updateList,
  updateListSuccess,
  updateListFailure,
  getList,
  getFormNewFields,
  getFormEditFields,
  getFormDeleteFields
} from 'src/reducers/common/editableListReducer';

export const REDUCER_NAME = 'employmentTypes';

// Async Action Creators
export const updateEmploymentTypes = data => async (dispatch, getState) => {
  try {
    dispatch(updateList(REDUCER_NAME));
    const httpBody = {
      employmentTypes: {
        creatings: getFormNewFields(getState(), REDUCER_NAME, data),
        updatings: getFormEditFields(getState(), REDUCER_NAME, data),
        deletings: getFormDeleteFields(getState(), REDUCER_NAME, data)
      }
    };
    const response = await axios.post(Urls.CREATE_CLIENT_EMPLOYMENT_TYPES_URL, httpBody);
    const values = response.data.payload;
    dispatch(updateListSuccess(REDUCER_NAME, values.clientEmploymentTypes));
    dispatch(initializeForm(EMPLOYMENT_TYPE_FORM, { [EDITABLE_LIST_FIELDS_NAME]: getList(REDUCER_NAME, getState()) }));
  } catch (exception) {
    dispatch(updateListFailure(REDUCER_NAME, exception.response.data.errors.messages));
  }
};

export default combineReducers({
  list: createNamedWrapperReducer(editableListReducer, REDUCER_NAME)
});
